import { useNavigate, useLocation } from 'react-router-dom';

// material mui
import {
    Typography,
    Grid,
    Avatar,
    Link,
    Chip,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import DEFAULT_USER_IMAGE from 'assets/images/users/default_user.png';
import { BOOKING_STATUS, PAYMENT_STATUS, USER_TYPE } from 'store/constant';

// third party
import moment from 'moment';

const List = ({ rows, page, limit, viewType }) => {

    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    // const getHours = (totalMinutes) => {
    //     const hours = Math.floor(totalMinutes / 60);
    //     const minutes = totalMinutes % 60;
    //     return `${hours}hr ${minutes}mins`;
    // };

    const handleViewVenue = (venue_uuid) => {
        navigate(`/venue/view/${venue_uuid}`)
    };

    const capitalizeFLetter = (str) => {
        return str ? str.replace(/^\w/, (c) => c.toUpperCase()) : '';
    };

    const getUserType = function (userType) {
        let findObj = USER_TYPE.find(x => x.value === userType);
        return findObj ? findObj.name : '';
    };

    const getBookingStatus = (booking_status) => {
        let findObj = BOOKING_STATUS.find(x => x.value === booking_status);
        return findObj ? findObj.name : '';
    };

    const getPaymentStatus = (payment_status) => {
        let findObj = PAYMENT_STATUS.find(x => x.value === payment_status);
        return findObj ? findObj.name : '';
    };

    const getAmount = (amount) => {
        return parseFloat(amount).toFixed(2);
    };

    const handleBookingDetails = (bookingType, bookingId) => {
        const pathparts = path.split('/');
        if (path.startsWith('/board/view')) {
            const boardUuid = pathparts[3];
            navigate(`/board/view/${boardUuid}/booking/${bookingId}`);
        } else if (path.startsWith('/venue/view')) {
            const venueUuid = pathparts[3];
            navigate(`/venue/view/${venueUuid}/${bookingType}/${bookingId}`);
        } else {
            navigate(`/bookings/${bookingType}/details/${bookingId}`);
        }
    };

    function formatDuration(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} >Booking Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Customer</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Venue</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Start Date</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>End Date</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Booked Duration</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Revoked At</TableCell>
                        {/* <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Played Duration</TableCell> */}
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Board Used Hours</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Total Amount</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Mode</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Type</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Booking Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Payment Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Created By</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                <Link
                                                    sx={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleBookingDetails('board', row.uuid)}>
                                                    {row.code}
                                                </Link>
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="User" src={row.booked_user_image ? row.booked_user_image : DEFAULT_USER_IMAGE} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.booked_user_firstname} {row.booked_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.booked_user_code} / {getUserType(row.booked_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {
                                                    viewType ? (row.venue_name ? row.venue_name : '') : (
                                                        <Link underline='always' onClick={() => handleViewVenue(row.uuid_venue)} sx={{
                                                            cursor: 'pointer'
                                                        }}>{row.venue_name ? row.venue_name : ''}</Link>
                                                    )
                                                }
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.court_name ? row.court_name : ''} / {row.board_name ? row.board_name : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {row.start_date ? moment(row.start_date.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY') : ''}
                                    </Typography>
                                    <Typography align="left" variant="subtitle2" component="div">
                                        {moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').format('hh:mm A')}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {moment(row.end_date.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                    </Typography>
                                    <Typography align="left" variant="subtitle2" component="div">
                                        {row.end_date ? moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(row.duration), 'minutes').format('hh:mm A') : ''}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {row.duration} Minutes
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px', textAlign: 'center' }}>
                                    {
                                        row.revoke_duration ? (
                                            <>
                                                <Typography align="left" variant="subtitle1" component="div">
                                                    {moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(row.revoke_duration), 'minutes').format('DD-MM-YYYY')}
                                                </Typography>
                                                <Typography align="left" variant="subtitle2" component="div">
                                                    {moment(row.start_date + ' ' + row.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(row.revoke_duration), 'minutes').format('hh:mm:ss A')}
                                                </Typography>
                                            </>
                                        ) : '-'
                                    }
                                </TableCell>
                                {/* <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {
                                        row.revoke_duration ? (
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.revoke_duration} Minutes
                                            </Typography>
                                        ) : ''
                                    }
                                </TableCell> */}
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px', textAlign: 'center' }}>
                                    {
                                        row.used_duration ? (
                                            <Typography align="center" variant="subtitle1" component="div">
                                                {formatDuration(row.used_duration)}
                                            </Typography>
                                        ) : '-'
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px', textAlign: 'center' }} align='right'>
                                    {getAmount(row.total)}
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_mode === 'full' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : row.payment_mode === 'custom' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : row.payment_mode === 'na' ? '-' : (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_mode)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_type === 'offline' ? (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_type)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label={capitalizeFLetter(row.payment_type)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.booking_status === 'confirmed' ? (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (row.booking_status === 'failed' || row.booking_status === 'cancelled') ? (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label={getBookingStatus(row.booking_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.payment_type === 'offline' || row.total === 0 ? '-' :
                                            row.payment_status === 'confirmed' ? (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.success.light + 60,
                                                        color: theme.palette.success.dark
                                                    }}
                                                />
                                            ) : row.payment_status === 'cancelled' ? (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.error.light + 60,
                                                        color: theme.palette.error.dark
                                                    }}
                                                />
                                            ) : (
                                                <Chip
                                                    label={getPaymentStatus(row.payment_status)}
                                                    size="medium"
                                                    sx={{
                                                        background:
                                                            theme.palette.mode === 'dark'
                                                                ? theme.palette.dark.main
                                                                : theme.palette.warning.light + 60,
                                                        color: theme.palette.warning.dark
                                                    }}
                                                />
                                            )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.deleted === 0 ? (

                                            <Chip
                                                label="Active"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label="Inactive"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.created_user_firstname} {row.created_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.created_user_code} / {getUserType(row.created_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
        </TableContainer >
    );
}

export default List;